// extracted by mini-css-extract-plugin
export default {"item":"QuoteItem_item__okbdp"};